// @@ AI-COMMENT: TechCard component to display individual technology with icon and proficiency
import { useState } from "react";
import { Card } from "react-bootstrap";
import { FaJava, FaServer } from "react-icons/fa";
import {
  SiAdobeillustrator,
  SiAdobeindesign, SiAdobephotoshop,
  SiAmazonaws, SiAngular,
  SiApachekafka,
  SiAppstore,
  SiBlender,
  SiBootstrap,
  SiC,
  SiCss3,
  SiD3Dotjs,
  SiDart,
  SiDjango,
  SiDocker,
  SiElasticsearch,
  SiExpress,
  SiFirebase, SiFlask,
  SiFlutter,
  SiGit,
  SiGoogleplay,
  SiHeroku,
  SiHibernate,
  SiHtml5,
  SiIcloud,
  SiIonic,
  SiJavascript,
  SiJetpackcompose,
  SiKotlin,
  SiMariadb,
  SiMongodb,
  SiMysql,
  SiNestjs,
  SiNetlify,
  SiNginx,
  SiNodedotjs,
  SiNumpy, SiPython, SiPytorch,
  SiRabbitmq,
  SiReact,
  SiRedis,
  SiRuby, SiRubyonrails,
  SiSpring,
  SiSpringboot,
  SiSpringsecurity,
  SiTailwindcss,
  SiTensorflow
} from "react-icons/si";
import styles from "./TechCard.module.css";

// @@ AI-COMMENT: Icon mapping object with all available technology icons
const icons = {
  AdobeIllustrator: <SiAdobeillustrator className={styles.icon} style={{ color: "#FF9A00" }} />,
  AdobeIndesign: <SiAdobeindesign className={styles.icon} style={{ color: "#FF3366" }} />,
  AdobePhotoshop: <SiAdobephotoshop className={styles.icon} style={{ color: "#31A8FF" }} />,
  AppleAppStore: <SiAppstore className={styles.icon} style={{ color: "#0D96F6" }} />,
  Angular: <SiAngular className={styles.icon} style={{ color: "#DD0031" }} />,
  AWS: <SiAmazonaws className={styles.icon} style={{ color: "#232F3E" }} />,
  Blender: <SiBlender className={styles.icon} style={{ color: "#F5792A" }} />,
  Bootstrap: <SiBootstrap className={styles.icon} style={{ color: "#7952B3" }} />,
  CSS: <SiCss3 className={styles.icon} style={{ color: "#1572B6" }} />,
  C: <SiC className={styles.icon} style={{ color: "#1572B6" }} />,
  D3dotjs: <SiD3Dotjs className={styles.icon} style={{ color: "#F9A03C" }} />,
  Dart: <SiDart className={styles.icon} style={{ color: "#0175C2" }} />,
  Django: <SiDjango className={styles.icon} style={{ color: "#092E20" }} />,
  Docker: <SiDocker className={styles.icon} style={{ color: "#092E20" }} />,
  Express: <SiExpress className={styles.icon} style={{ color: "#000000" }} />,
  Firebase: <SiFirebase className={styles.icon} style={{ color: "#FFCA28" }} />,
  Flask: <SiFlask className={styles.icon} style={{ color: "#000000" }} />,
  Flutter: <SiFlutter className={styles.icon} style={{ color: "#02569B" }} />,
  Git: <SiGit className={styles.icon} style={{ color: "#F05032" }} />,
  GooglePlay: <SiGoogleplay className={styles.icon} style={{ color: "#414141" }} />,
  Heroku: <SiHeroku className={styles.icon} style={{ color: "#430098" }} />,
  Hibernate: <SiHibernate className={styles.icon} style={{ color: "#430098" }} />,
  HTML: <SiHtml5 className={styles.icon} style={{ color: "#E34F26" }} />,
  Ionic: <SiIonic className={styles.icon} style={{ color: "#3880FF" }} />,
  Java: <FaJava className={styles.icon} style={{ color: "#ED8B00" }} />,
  JavaScript: <SiJavascript className={styles.icon} style={{ color: "#F7DF1E" }} />,
  JetpackCompose: <SiJetpackcompose className={styles.icon} style={{ color: "#4285F4" }} />,
  Kotlin: <SiKotlin className={styles.icon} style={{ color: "#7F52FF" }} />,
  Kafka: <SiApachekafka className={styles.icon} style={{ color: "##231F20" }} />,
  Tensorflow: <SiTensorflow className={styles.icon} style={{ color: "#FF6F00" }} />,
  MongoDB: <SiMongodb className={styles.icon} style={{ color: "#47A248" }} />,
  MySQL: <SiMysql className={styles.icon} style={{ color: "#4479A1" }} />,
  MariaDB: <SiMariadb className={styles.icon} style={{ color: "#4479A1" }} />,
  Microservices: <FaServer className={styles.icon} style={{ color: "#4479A1" }} />,
  NestJS: <SiNestjs className={styles.icon} style={{ color: "#E0234E" }} />,
  Netlify: <SiNetlify className={styles.icon} style={{ color: "#00C7B7" }} />,
  Nginx: <SiNginx className={styles.icon} style={{ color: "#009639" }} />,
  Nodedotjs: <SiNodedotjs className={styles.icon} style={{ color: "#339933" }} />,
  NumPy: <SiNumpy className={styles.icon} style={{ color: "#013243" }} />,
  Python: <SiPython className={styles.icon} style={{ color: "#3776AB" }} />,
  PyTorch: <SiPytorch className={styles.icon} style={{ color: "#EE4C2C" }} />,
  RabbitMQ: <SiRabbitmq className={styles.icon} style={{ color: "#FF6600" }} />,
  React: <SiReact className={styles.icon} style={{ color: "#61DAFB" }} />,
  Redis: <SiRedis className={styles.icon} style={{ color: "#FF4438" }} />,
  RESTful: <span className={styles.icon} style={{ color: "#25D366", fontWeight: "bold", fontSize: "0.8rem" }}>REST</span>,
  Ruby: <SiRuby className={styles.icon} style={{ color: "#CC342D" }} />,
  RubyOnRails: <SiRubyonrails className={styles.icon} style={{ color: "#D30001" }} />,
  Spring: <SiSpring className={styles.icon} style={{ color: "#6DB33F" }} />,
  SpringBoot: <SiSpringboot className={styles.icon} style={{ color: "#6DB33F" }} />,
  SpringCloud: <SiIcloud className={styles.icon} style={{ color: "#6DB33F" }} />,
  SpringSecurity: <SiSpringsecurity className={styles.icon} style={{ color: "#6DB33F" }} />,
  Elasticsearch: <SiElasticsearch className={styles.icon} style={{ color: "#005571" }} />,
  TailwindCSS: <SiTailwindcss className={styles.icon} style={{ color: "#38B2AC" }} />,
};

// @@ AI-COMMENT: Proficiency level color mapping
const proficiencyColors = {
  Expert: "#4CAF50",     // Green
  Advanced: "#2196F3",   // Blue
  Intermediate: "#FF9800", // Orange
  Beginner: "#9C27B0"    // Purple
};

const TechCard = ({ name, icon, proficiency, variant = "default" }) => {
  // @@ AI-COMMENT: State for hover animations
  const [isHovered, setIsHovered] = useState(false);
  
  // @@ AI-COMMENT: Minimal variant for professional layout
  if (variant === "minimal") {
    return (
      <div 
        className={`${styles.minimalCard} ${isHovered ? styles.minimalHovered : ''}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className={styles.minimalIcon}>
          {icons[icon] || (
            <div className={styles.fallbackIcon}>{name.charAt(0)}</div>
          )}
        </div>
        <span className={styles.minimalName}>{name}</span>
      </div>
    );
  }
  
  // @@ AI-COMMENT: Default card variant (existing implementation)
  return (
    <Card 
      className={`${styles.card} ${isHovered ? styles.hovered : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Card.Body className={styles.cardBody}>
        <div className={styles.iconContainer}>
          {icons[icon] || (
            <div className={styles.fallbackIcon}>{name.charAt(0)}</div>
          )}
        </div>
        
        <div className={styles.content}>
          <h5 className={styles.techName}>{name}</h5>
          {proficiency && (
            <span 
              className={styles.proficiency}
              style={{ color: proficiencyColors[proficiency] }}
            >
              {proficiency}
            </span>
          )}
        </div>
        
        {proficiency && (
          <div 
            className={styles.proficiencyBar}
            style={{ backgroundColor: proficiencyColors[proficiency] }}
          />
        )}
      </Card.Body>
    </Card>
  );
};

export default TechCard;